/** Default max decoded buffers + waveforms kept in hub memory. */
export const SAMPLE_PLAYBACK_CACHE_MAX_ENTRIES = 20;

/** Waveform envelope point count (client + cabinet). */
export const SAMPLE_PLAYBACK_WAVEFORM_POINTS = 512;
